import { Box, Chip, Divider, TextField } from "@mui/material";
import { format } from "date-fns";

export type Outcome = {
  unit: string;
  value: number;
  isUnitOfSale: boolean;
  startDate?: number;
  endDate?: number;
};

const defaultOutcomeValue = "-";

const unitOfSaleColumnWidth = 104;

function ReadOnlyOutcome({
  outcome,
  index,
}: {
  outcome: Outcome;
  index: number;
}) {
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            gap: 2,
            flex: 1,
            minWidth: 0,
          }}
        >
          <TextField
            data-testid={`outcome-unit-${index}`}
            value={outcome.unit}
            variant="standard"
            label="Unit"
            size="small"
            fullWidth
            sx={{
              marginBottom: 2,
              flex: "2 1 0",
              minWidth: 0,
            }}
            InputProps={{
              readOnly: true,
              disableUnderline: true,
              sx: { "& input": { textOverflow: "ellipsis" } },
            }}
          />

          <TextField
            data-testid={`outcome-start-${index}`}
            value={
              outcome.startDate !== null && outcome.startDate !== undefined
                ? format(outcome.startDate, "dd/MM/yyyy")
                : defaultOutcomeValue
            }
            variant="standard"
            label="Start"
            size="small"
            fullWidth
            sx={{
              marginBottom: 2,
              flex: "1 1 0",
              minWidth: 0,
            }}
            InputProps={{
              readOnly: true,
              disableUnderline: true,
            }}
          />

          <TextField
            data-testid={`outcome-end-${index}`}
            value={
              outcome.endDate !== null && outcome.endDate !== undefined
                ? format(outcome.endDate, "dd/MM/yyyy")
                : defaultOutcomeValue
            }
            variant="standard"
            label="End"
            size="small"
            fullWidth
            sx={{
              marginBottom: 2,
              flex: "1 1 0",
              minWidth: 0,
            }}
            InputProps={{
              readOnly: true,
              disableUnderline: true,
            }}
          />

          <TextField
            data-testid={`outcome-value-${index}`}
            value={outcome.value}
            variant="standard"
            label="Value"
            size="small"
            fullWidth
            sx={{
              marginBottom: 2,
              flex: "1 1 0",
              minWidth: 0,
            }}
            InputProps={{
              readOnly: true,
              disableUnderline: true,
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            flexShrink: 0,
            width: unitOfSaleColumnWidth,
          }}
        >
          {outcome.isUnitOfSale && (
            <Chip
              data-testid={`outcome-unit-of-sale-${index}`}
              label="Unit of Sale"
              color="secondary"
            />
          )}
        </Box>
      </Box>
      <Divider sx={{ marginBottom: 2 }} />
    </>
  );
}

export default ReadOnlyOutcome;
